class CompanyDashboardSidebar extends Tango.Component {

	widgetDidMount() {
		const root = document.getElementById(this.root).parentElement.parentElement.parentElement;
		root.classList.add('dash_sidebar');

		const fold = root.querySelector('.icon-fold');
		const fold2 = document.querySelector('.company-btn-sidebar');
		const foldSmall = root.querySelector('.icon-fold-small');
		fold.onclick = e => {
			domActions.toggleClass({ id: root.id, clsName: 'state1' });
			if (Tango.isMobile())
				domActions.toggleClass({ id: 'body', clsName: 'lock-position-body' });
		};
		fold2.onclick = fold.onclick;
		foldSmall.onclick = fold.onclick;
		root.onclick = e => {
			if (root.classList.contains('state1')) {
				domActions.toggleClass({ id: root.id, clsName: 'state1' });
				if (Tango.isMobile())
					domActions.toggleClass({ id: 'body', clsName: 'lock-position-body' });
			}
		};
	}
}

class CompanyDashboardBlock extends Tango.Component {

	widgetDidMount() {
		const root = document.getElementById(this.root);
		const header = root.querySelector('.block-header-left');
		const parmName = root.getAttribute('data-ctrl-name') + ':collapsed';

		header.removeAttribute('onclick');
		header.addEventListener('click', e => {
			domActions.toggleClass({ id: root.id, clsName: 'collapsed' });
			localStorage.setItem(parmName, root.classList.contains('collapsed'));
		});
		if (localStorage.getItem(parmName) == 'true')
			root.classList.add('collapsed');
	}
}

class CompanyFilingsYearBlock extends Tango.Component {

	widgetDidMount() {
		const root = document.getElementById(this.root);
		const header = root.querySelector('.block-header-left');

		header.removeAttribute('onclick');
		header.addEventListener('click', e => {
			domActions.toggleClass({ id: root.id, clsName: 'collapsed' });
			if (!root.hasAttribute('data-loaded')) {
				ajaxUtils.postEventFromElementWithApiResponse(header);
				root.setAttribute('data-loaded', '1');
			}
			return false;
		});
	}
}

Tango.registerComponent(CompanyDashboardSidebar);
Tango.registerComponent(CompanyDashboardBlock);
Tango.registerComponent(CompanyFilingsYearBlock);